import { useUpdateUsuario } from "@retro-ia/shared/hooks";
import SwitchActivo from "@/components/ui/SwitchActivo";
import type { ClienteFinal } from "@/interfaces/user.interface";

interface CeldaSwitchActivoProps {
  clienteFinal: ClienteFinal;
}

const CeldaSwitchActivo: React.FC<CeldaSwitchActivoProps> = ({
  clienteFinal,
}) => {
  const updateUsuario = useUpdateUsuario({ queryKey: ["misClientesFinales"] });

  return (
    <SwitchActivo
      id={clienteFinal.id}
      isActivo={clienteFinal.isActivo}
      useUpdateHook={() => updateUsuario}
      getPayload={(newValue: boolean) => ({
        data: { isActivo: newValue },
      })}
    />
  );
};

export default CeldaSwitchActivo;

